import Web3 from 'web3'
var web3=new Web3()
window['web3']=web3
export default web3 